export default __webpack_public_path__ + "static/media/check.e9231ca7.svg";